// src/Components/Drawer/Markup/MarkersTabMenu.js

import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import {
  MenuAddNew,
  MenuAddNewGrey,
  MenuSave,
  MenuSaveGrey,
  MenuDelete,
  MenuDeleteGrey,
  MenuIconCancel,
  MenuIconCancelGrey,
} from '../../../assets/icons/CustomIcons';

export default function MarkersTabMenu({
  handleHeaderAction,
  activeAction,
  selectedMarker,
  isDirty,
  pointsPlaced,
  activeTab,
  isAppFullScreen,
}) {
  const toolBlockStyle = {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minWidth: 0,
  };

  const ICON_SIZE = 64; // Retained original icon size

  const isAddingNew = activeAction === 'ADD_NEW';
  const isEditing = activeAction === 'EDIT';
  const isSaving = activeAction === 'SAVE';

  // AMENDED: Strictly check for a real marker (id or isNew) to ignore the empty tempData placeholder
  const isSelected = !!(selectedMarker && (selectedMarker.id || selectedMarker.isNew));

  let isMatchingType = false;
  if (selectedMarker) {
    const t = (selectedMarker.type || '').toLowerCase();
    if (activeTab === 'MARKERS' && t === 'marker') isMatchingType = true;
    if (activeTab === 'POLYGON' && t === 'polygon') isMatchingType = true;
    if (activeTab === 'POLYLINE' && (t === 'line' || t === 'polyline'))
      isMatchingType = true;
    // VisHover is a property tab applicable to ALL geometry types
    if (activeTab === 'VIS_HOVER') isMatchingType = true;
  }

  const isVisHover = activeTab === 'VIS_HOVER';

  // Explicitly disable Add New when interacting with the Vis Hover panel
  const disableAdd =
    isSaving || (isSelected && isMatchingType) || isAddingNew || isVisHover;

  const isSaveActive = isDirty && !(isAddingNew && !pointsPlaced);
  const enableSave = isSaveActive && !isSaving;

  // AMENDED: Added isAppFullScreen to force the Cancel button active as a full-screen exit trigger
  const enableCancel =
    isAddingNew || isEditing || isSelected || isDirty || isAppFullScreen;

  // With isMatchingType corrected for VIS_HOVER, Delete will correctly activate
  const disableDelete = !isSelected || isSaving || !isMatchingType;

  // Squashed the clickable focus area into a sleek rectangle that fits the 45px bar
  const buttonSx = {
    p: 0,
    height: '38px',
    width: '60px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
    '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' },
    // Shifts the oversized SVG up by 8px to reveal the text cut off at the bottom
    '& svg': { transform: 'translateY(-8px)' },
  };

  return (
    <Box
      sx={{
        height: '100%', // Fills the 45px wrapper
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '5px',
        paddingRight: '5px',
      }}>
      <Box sx={toolBlockStyle}>
        <IconButton
          sx={buttonSx}
          disabled={disableAdd}
          onClick={() => handleHeaderAction('ADD_NEW')}>
          {disableAdd ? (
            <MenuAddNewGrey sx={{ fontSize: ICON_SIZE }} />
          ) : (
            <MenuAddNew sx={{ fontSize: ICON_SIZE }} />
          )}
        </IconButton>
      </Box>

      <Box sx={toolBlockStyle}>
        <IconButton
          sx={buttonSx}
          disabled={!enableSave}
          onClick={() => handleHeaderAction('SAVE')}>
          {isSaveActive ? (
            <MenuSave sx={{ fontSize: ICON_SIZE }} />
          ) : (
            <MenuSaveGrey sx={{ fontSize: ICON_SIZE }} />
          )}
        </IconButton>
      </Box>

      <Box sx={toolBlockStyle}>
        <IconButton
          sx={buttonSx}
          disabled={disableDelete}
          onClick={() => handleHeaderAction('DELETE')}>
          {disableDelete ? (
            <MenuDeleteGrey sx={{ fontSize: ICON_SIZE }} />
          ) : (
            <MenuDelete sx={{ fontSize: ICON_SIZE }} />
          )}
        </IconButton>
      </Box>

      <Box sx={toolBlockStyle}>
        <IconButton
          sx={buttonSx}
          disabled={!enableCancel}
          onClick={() => handleHeaderAction('CLOSE')}>
          {enableCancel ? (
            <MenuIconCancel sx={{ fontSize: ICON_SIZE }} />
          ) : (
            <MenuIconCancelGrey sx={{ fontSize: ICON_SIZE }} />
          )}
        </IconButton>
      </Box>
    </Box>
  );
}
